export default "__VITE_ASSET__BdTJmC1U__"